// extracted by mini-css-extract-plugin
export default {"charactersRemainingText":"MaxLengthTextWidget_charactersRemainingText__jFV6H"};